import { createSelector } from '@reduxjs/toolkit';

import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const currentChatOwnerIdSelector = createSelector(
  [currentOpenChatSelector],
  currentOpenChat => currentOpenChat?.users.find(user => user.chatRole === 'initiator')?.userId,
);
